import { Switch } from '@/components/ui/Switch';

import {
  Root,
  Title,
  Description,
  Header,
  ItemLabel,
  ItemDescription,
  Group,
  GroupHeader,
  ItemHeader,
  Seperator,
  Item,
} from './settings-section.parts';

export const SettingsSection = {
  Root,
  Title,
  Description,
  Header,
  ItemLabel,
  ItemDescription,
  Group,
  GroupHeader,
  ItemHeader,
  Seperator,
  Item,
  Switch,
};
